const routes = [
  {
    id: 'about',
    name: 'About',
    path: '/about',
  },
  {
    id: 'referrals',
    name: 'Referrals',
    path: '/referrals',
  },
  {
    id: 'faq',
    name: 'Faq',
    path: '/faq',
  },
];

export default routes;
